module.exports = __webpack_public_path__ + "img/img1.51e30df3.png";